module.exports = __webpack_public_path__ + "fonts/Proxima Nova Extrabold.5243e362.otf";